import {observer} from 'mobx-react-lite'
import React from 'react'
import {Lang} from 'yougile-lang'
import {Time, Util} from 'yougile-util'
import {RepeatStickerEntry, SystemStickerType} from 'yougile-model'
import {EventBus} from '@client/event-bus'
import {openRepeatTemplatesEvent} from '@client/events'
import {RepeatClient} from '@client/repeat-client'
import {Sync} from '@client/sync'
import {MessageBox} from '@components/message-box'
import {StickerMenuHeader} from '@components/sticker/sticker-menu/sticker-menu-header'
import {useStickerStore} from '@components/sticker/sticker-store'
import {PageService} from '@extensions/page-service'
import {Button} from '../../../common/base/buttons'

export const StickerMenuRepeatTask = observer(() => {
  const [state, store] = useStickerStore()
  const value = state.value as RepeatStickerEntry
  const task = store.stickerTask

  const box = task && Sync.get(task)
  const col = task && box?.getHub(task.location)
  const boardId = col?.location ?? PageService.getCurrentBoard()?.id
  const bem = Util.bemFrom('repeat-view')

  const clickTpl = () => {
    if (!box) {
      return
    }

    const tpl = box.getHub(value.templateId)
    if (!tpl || tpl.deleted || !tpl.data.repeatTemplate) {
      MessageBox.warn(Lang.msg.repeat.templateDeleted)
    } else {
      store.closeStickerMenu()
      EventBus.dispatch(
        openRepeatTemplatesEvent({
          boardId: col?.location ?? PageService.getCurrentBoard()?.id,
          templateId: value.templateId
        })
      )
    }
  }

  const click = () => {
    store.closeStickerMenu()
    EventBus.dispatch(
      openRepeatTemplatesEvent({
        boardId
      })
    )
  }

  return (
    <div className="w-[233px]">
      <div className="sticker-item-list-head flex">
        <StickerMenuHeader
          stickerId={store.sticker.id}
          title={
            Lang.msg.stickerNames[
              store.stickerData.stickerType as SystemStickerType
            ]
          }
          showUnpin={false}
          showSettings={false}
        />
      </div>
      <div className="sticker-item-list-body">
        <div className={bem('cnt')}>
          {Lang.msg.repeat.repeatNumber} <b>№{value.repeatedNumber}</b>
          {value.repeatedNumber > 0 && task ? (
            <div className={bem('date')}>
              {Lang.msg.repeat.date}: {Time.formatDateTime(task.timestamp)}
            </div>
          ) : (
            <div className={bem('explain-0')}>
              {Lang.msg.repeat.explain0Repeat}
            </div>
          )}
          {boardId &&
            box &&
            value?.templateId &&
            RepeatClient.canEditRepeatTasks(box, boardId) && (
              <Button className="mt-6" size="small" onClick={clickTpl}>
                {Lang.msg.repeat.openTemplate}
              </Button>
            )}
          {boardId && (
            <div className={bem('open-all')} onClick={click}>
              {Lang.msg.repeat.showRepeatTasks} »
            </div>
          )}
        </div>
      </div>
    </div>
  )
})
